module.exports = __webpack_public_path__ + "img/pump-soap.6c047645.svg";